import { graphql } from "../gql";

export const unassignClaimsFromAuditGroupMutationDoc = graphql(`
  mutation unassignClaimsFromAuditGroup(
    $input: UnassignClaimsFromAuditGroupInput!
  ) {
    unassignClaimsFromAuditGroup(input: $input) {
      appealDueDate
      auditStartDate
      createdAt
      disputeDueDate
      finalProviderReportSentDate
      id
      name
      qaDueDate
      totalClaimsCount
    }
  }
`);
